/* istanbul ignore file */

export { LOADING_REVIEWS } from '../../CustomersReviewsPreview/constants/copy';

export const BACK = 'Back';
export const CLOSE = 'Close';
export const DRAWER_CONTENT_LABEL = 'Customer reviews';
export const REVIEW_DRAWER_CONTENT_LABEL = 'Customer review';
export const ERROR_REVIEWS = 'Reviews are unavailable right now. Please try again shortly.';
export const NEXT_PAGE = 'Next page';
export const PAGINATION_LABEL = 'Review pages';
export const NO_REVIEWS = 'No reviews for this product yet.';
export const PHOTOS_HEADING = 'Photos from reviews';
export const PREVIOUS_PAGE = 'Previous page';
export const RATING_HELP_HREF = '/rating_help.html';
export const VERIFIED_REVIEWS = 'Verified product reviews';

export const reviewCountHeading = (count: number) =>
  count === 1 ? '1 review' : `${count} reviews`;
